export default "__VITE_ASSET__D9sW1WUY__"